import * as React from "react";
import { Container } from "react-bootstrap";
import { styledContainer } from "./ParagraphFeaturedOffers.module.scss";

export const StyledContainer: React.FC<any> = (props) => {
  return (
    <Container className={`${styledContainer} mb-5 featuredOffers`}>
      {props.children}
    </Container>
  );
};
